import type { AudienceUser } from './mailingDomain';
import i18next from '../i18n/initI18n';

/** Подстановка {{key}} из профиля пользователя (и name как алиас userId). */
export function applyPersonalization(text: string, user: Partial<AudienceUser> | null | undefined): string {
  if (!text) return '';
  const u = user || {};
  const map: Record<string, string> = {
    userId: String(u.userId ?? ''),
    name: String(u.userId ?? ''),
    phone: String(u.phone ?? ''),
    email: String(u.email ?? ''),
    pushToken: String(u.pushToken ?? ''),
    viberId: String(u.viberId ?? ''),
    wabaId: String(u.wabaId ?? ''),
  };
  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key: string) => map[key] ?? '');
}

export const SAMPLE_AUDIENCE_USER: AudienceUser = {
  userId: 'demo_user',
  phone: '+79001234567',
  email: 'user@example.com',
  pushToken: 'demo_push_token',
  viberId: 'viber_demo',
  wabaId: 'waba_demo',
};

/** Приблизительная длина SMS в сегментах GSM-7 (без UCS-2): одна часть до 160 символов. */
export function smsGsmUnits(text: string): { singleSegmentLimit: number; segments: number; chars: number } {
  const chars = [...text].length;
  const limit = 160;
  if (chars === 0) return { singleSegmentLimit: limit, segments: 0, chars: 0 };
  const segments = Math.ceil(chars / limit);
  return { singleSegmentLimit: limit, segments, chars };
}

export function smsLengthWarning(text: string): string | null {
  const { segments, chars, singleSegmentLimit } = smsGsmUnits(text);
  if (chars > singleSegmentLimit * 3) {
    return i18next.t('personalization.longSms', { segments, chars });
  }
  if (chars > singleSegmentLimit) {
    return i18next.t('personalization.smsSplit', { segments, limit: singleSegmentLimit });
  }
  return null;
}
